// src/components/NoticePopup/styled.js
import styled from 'styled-components';

export const NoticeContent = styled.div`
  font-size: 14px;
  line-height: 1.6;
  color: #666;
  max-height: 300px;
  overflow-y: auto;
`;
